import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurveyCompletedDark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 329.899,
			y1: 62.5615,
			x2: 394.899,
			y2: 47.5615,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 316.649,
			y1: 59.2811,
			x2: 300.649,
			y2: 39.2811,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 289.182,
			y1: 36.4117,
			x2: 221.182,
			y2: 66.4117,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 38C398.582 38 395 41.5817 395 46C395 50.4183 398.582 54 403 54C407.418 54 411 50.4183 411 46C411 41.5817 407.418 38 403 38Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M403 43C401.343 43 400 44.3431 400 46C400 47.6569 401.343 49 403 49C404.657 49 406 47.6569 406 46C406 44.3431 404.657 43 403 43Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296 25C291.582 25 288 28.5817 288 33C288 37.4183 291.582 41 296 41C300.418 41 304 37.4183 304 33C304 28.5817 300.418 25 296 25Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296 30C294.343 30 293 31.3431 293 33C293 34.6569 294.343 36 296 36C297.657 36 299 34.6569 299 33C299 31.3431 297.657 30 296 30Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M322 56.999C317.582 56.999 314 60.5807 314 64.999C314 69.4173 317.582 72.999 322 72.999C326.418 72.999 330 69.4173 330 64.999C330 60.5807 326.418 56.999 322 56.999Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M322 61.999C320.343 61.999 319 63.3422 319 64.999C319 66.6559 320.343 67.999 322 67.999C323.657 67.999 325 66.6559 325 64.999C325 63.3422 323.657 61.999 322 61.999Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3229,
			y2: -.45,
			transform: "matrix(0.920735 0.390189 0.390189 -0.920735 127.568 16)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(-0.991998 -0.126254 -0.126254 0.991998 72 82)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(-0.484316 0.874893 0.874893 0.484316 115 19)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 90C75.5817 90 72 86.4183 72 82C72 77.5817 75.5817 74 80 74C84.4183 74 88 77.5817 88 82C88 86.4183 84.4183 90 80 90Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 85C78.3431 85 77 83.6569 77 82C77 80.3431 78.3431 79 80 79C81.6569 79 83 80.3431 83 82C83 83.6569 81.6569 85 80 85Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 82C4.58172 82 1 78.4183 1 74C1 69.5817 4.58172 66 9 66C13.4183 66 17 69.5817 17 74C17 78.4183 13.4183 82 9 82Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 77C7.34315 77 6 75.6569 6 74C6 72.3431 7.34315 71 9 71C10.6569 71 12 72.3431 12 74C12 75.6569 10.6569 77 9 77Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120 21C115.582 21 112 17.4183 112 13C112 8.58172 115.582 5 120 5C124.418 5 128 8.58172 128 13C128 17.4183 124.418 21 120 21Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M120 16C118.343 16 117 14.6569 117 13C117 11.3431 118.343 10 120 10C121.657 10 123 11.3431 123 13C123 14.6569 121.657 16 120 16Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M110.3 121.65C110.3 123.67 108.67 125.3 106.65 125.3C104.63 125.3 103 123.67 103 121.65C103 119.63 104.63 118 106.65 118C108.67 118 110.3 119.63 110.3 121.65Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M259.3 3.64996C259.3 5.66996 257.67 7.29999 255.65 7.29999C253.63 7.29999 252 5.66996 252 3.64996C252 1.62996 253.63 0 255.65 0C257.67 0 259.3 1.62996 259.3 3.64996Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .74,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M262.502 128C245.302 118.4 229.668 106.667 224.002 102C224.002 102 212.846 107.578 213.002 107.5C219.965 117.945 235.335 135.5 240.502 140H285.502C285.002 140 279.702 137.6 262.502 128Z",
				fill: "#3F3F41"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.872 53.0071L180.549 62.2914L179.975 74.4884C179.793 78.3673 179.275 82.1903 178.449 85.9572L164.669 58.6365C163.115 55.5557 164.361 51.7748 167.442 50.2204C168.996 49.4362 170.719 49.3662 172.231 49.8703C173.758 50.3744 175.088 51.4527 175.872 52.9931V53.0071Z",
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M208.431 116.036L179.654 58.9443L178.744 74.5021C178.562 78.3811 178.043 82.204 177.217 85.971C176.713 88.3235 176.055 90.6482 175.299 92.9447C171.896 103.111 172.26 114.132 176.321 124.032L179.122 130.838L179.178 130.992L208.445 116.036H208.431Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M206.921 117.017C207.733 118.628 202.188 123.067 194.528 126.932C186.868 130.796 179.992 132.617 179.18 130.993C178.368 129.382 183.913 124.943 191.573 121.078C199.233 117.213 206.109 115.393 206.921 117.017Z",
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M211.932 32.4655L216.61 41.7498L226.762 48.5415C229.983 50.6981 233.372 52.5605 236.901 54.1289L223.135 26.8082C221.581 23.7274 217.8 22.4811 214.719 24.0355C213.165 24.8197 212.086 26.164 211.596 27.6764C211.092 29.2028 211.176 30.9111 211.946 32.4655H211.932Z",
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M273.999 82.6664L273.916 82.5276L270.134 76.2837C264.628 67.2092 256.049 60.4242 245.913 57.1497C243.633 56.4143 241.38 55.554 239.211 54.5689C235.707 53.0148 232.357 51.1694 229.145 49.0326L216.2 40.5825L244.773 97.1522L273.986 82.6525L273.999 82.6664Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.566 96.581C245.425 98.1498 252.699 96.3763 260.803 92.6248C268.906 88.8596 274.773 84.5352 273.914 82.9664C273.055 81.3975 265.781 83.1709 257.677 86.9225C249.573 90.6877 243.707 95.0122 244.566 96.581Z",
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185.117 5.74493L168.467 14.147L169.867 3.43433C170.217 0.689655 173.256 -0.850689 175.692 0.493642L185.131 5.74493H185.117Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M211.275 30.9934L244.883 97.6637L206.822 116.848L173.213 50.178C168.438 40.6977 166.548 29.999 167.78 19.4545L168.466 14.1472L185.116 5.74512L189.794 8.34974C199.022 13.615 206.486 21.513 211.261 30.9934H211.275Z",
			fill: "#3F3F41"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M195.645 68.0601C204.187 85.0182 218.793 96.8792 235.513 102.383L206.82 116.848L173.212 50.1917C168.423 40.6973 166.532 30.0127 167.779 19.4681L168.479 14.1609L185.129 5.75879L189.806 8.34939C191.108 9.09157 192.369 9.87578 193.587 10.73C186.151 28.5844 186.249 49.4495 195.645 68.0601Z",
			fill: "#1C1C1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.442 115.591L242.405 98.9768L244.069 102.278C244.592 103.316 244.182 104.589 243.132 105.118L213.933 119.835C212.896 120.359 211.623 119.949 211.093 118.899L209.429 115.598L209.442 115.591Z",
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241.647 105.786L242.011 106.5C243.439 109.328 242.641 112.689 240.274 114.594C239.924 114.888 239.518 115.14 239.098 115.35L224.675 122.618C224.254 122.828 223.806 123.01 223.358 123.108C220.417 123.878 217.239 122.52 215.81 119.691L215.446 118.977L241.647 105.771V105.786Z",
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M208.863 47.8999C211.617 53.3569 209.422 60.0067 203.965 62.7606C198.508 65.5144 191.858 63.319 189.104 57.862C186.35 52.4051 188.546 45.7552 194.003 43.0014C199.46 40.2476 206.109 42.443 208.863 47.8999Z",
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M211.283 45.5022C207.864 38.8872 199.61 36.2259 192.836 39.5641",
			stroke: "#EAEAEA",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.914 74.1098L202.857 83.2113C201.6 83.8448 201.095 85.3773 201.729 86.6343L202.718 88.5975C203.352 89.8545 204.884 90.3598 206.141 89.7263L224.198 80.6249C225.455 79.9913 225.96 78.4588 225.327 77.2018L224.337 75.2386C223.704 73.9816 222.171 73.4763 220.914 74.1098Z",
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.437 20.2907C206.977 16.6013 204.518 14.1418 200.828 11.0673C197.139 7.9929 195.294 6.76312 191.605 4.91846",
			stroke: "#EAEAEA",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M181.766 127.282C183.611 125.643 187.398 122.922 191.605 120.519C195.909 118.059 197.753 117.444 202.673 116.214",
			stroke: "#EAEAEA",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M247.561 92.8476C249.406 91.2079 252.946 87.9923 257.399 86.0839C261.704 84.2392 264.778 83.0094 269.697 82.3945",
			stroke: "#EAEAEA",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M293.043 116.173C292.833 116.183 292.623 116.133 292.433 116.003C291.983 115.693 291.863 115.083 292.173 114.633L297.933 106.193C298.103 105.943 298.383 105.783 298.683 105.763C298.963 105.733 299.283 105.863 299.483 106.083L303.203 110.173L309.873 99.1326C310.033 98.8726 310.293 98.7026 310.593 98.6626C310.893 98.6326 311.193 98.7326 311.413 98.9426L315.463 102.973L324.013 90.4326C324.323 89.9826 324.933 89.8626 325.383 90.1726C325.833 90.4826 325.953 91.0926 325.643 91.5426L316.433 105.063C316.273 105.303 316.003 105.463 315.713 105.493C315.403 105.533 315.133 105.413 314.923 105.213L310.923 101.233L304.223 112.333C304.063 112.603 303.783 112.773 303.473 112.803C303.143 112.843 302.853 112.713 302.643 112.483L298.873 108.343L293.823 115.753C293.643 116.013 293.353 116.163 293.063 116.183L293.043 116.173Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.0426 20.01C39.8326 20 39.6226 20.0499 39.4326 20.1799C38.9826 20.4899 38.8626 21.1 39.1726 21.55L44.9326 29.99C45.1026 30.24 45.3826 30.4001 45.6826 30.4201C45.9626 30.4501 46.2826 30.32 46.4826 30.1L50.2026 26.01L56.8726 37.0501C57.0326 37.3101 57.2926 37.48 57.5926 37.52C57.8926 37.55 58.1926 37.45 58.4126 37.24L62.4626 33.21L63.5 32.1826C63.6284 31.9243 63.5926 31.36 63.4326 31.12C63.2726 30.88 63.0026 30.7199 62.7126 30.6899C62.4026 30.6499 62.1326 30.77 61.9226 30.97L57.9226 34.95L51.2226 23.85C51.0626 23.58 50.7826 23.41 50.4726 23.38C50.1426 23.34 49.8526 23.47 49.6426 23.7L45.8726 27.84L40.8226 20.4299C40.6426 20.1699 40.3526 20.02 40.0626 20L40.0426 20.01Z",
			fill: "#40C676"
		})
	]
});
const ForwardRef = forwardRef(SvgSurveyCompletedDark);
export default ForwardRef;
